/*
 * @Author: WLL
 * @Date: 2020-04-16 22:17:49
 * @LastEditors: WLL
 * @LastEditTime: 2020-05-09 15:50:37
 * @Description: 工具函数
 */
import pdfIcon from "@/assets/images/pdf.png";
import wordIcon from "@/assets/images/word.png";
import htmlIcon from "@/assets/images/html.png";
import fileIcon from "@/assets/images/file.png";
import Moment from "moment";
import downloadjs from "downloadjs";

export function getUrlParams(name) {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
        location.href
        // eslint-disable-next-line no-sparse-arrays
      ) || [, ""])[1].replace(/\+/g, "%20")
    ) || null
  );
}

export function highlightHtml(str, key) {
  if (!key) return str;
  const matchOperatorsRegex = /[|\\{}()[\]^$+*?.-]/g;
  const reg = new RegExp(key.replace(matchOperatorsRegex, "\\$&"), "gi");
  return str.replace(reg, match => `<span class="highlight">${match}</span>`);
}

export function publishChartDateFormatter(date) {
  return Moment(date).format("YYYY.MM.DD");
}

export function publishDateFormatter(date) {
  return Moment(date).format("M月D日");
}

export function publishMDDateFormatter(date) {
  return Moment(date).format("M月D日");
}

export function dateSort(date1, date2) {
  return Moment(date1).valueOf() - Moment(date2).valueOf();
}

export const fileTypeMap = {
  pdf: {
    type: "pdf",
    test: /\.pdf$/i,
    icon: pdfIcon
  },
  word: {
    type: "word",
    test: /\.(doc|docx)$/i,
    icon: wordIcon
  },
  html: {
    type: "html",
    test: /\.html$/i,
    icon: htmlIcon
  },
  file: {
    type: "file",
    test: /\.*$/,
    icon: fileIcon
  }
};

export function getFileType(url = "") {
  let type;
  Object.keys(fileTypeMap).every(key => {
    if (typeof url === "string" && url.match(fileTypeMap[key].test)) {
      type = fileTypeMap[key];
      return false;
    }
    return true;
  });
  return type;
}

export function tooltipFormatter(params) {
  const data = params[0];
  return `${data.axisValueLabel}<br/>${data.marker}${data.seriesName}：${data.value}%`;
}

export function download(url, name) {
  const x = new XMLHttpRequest();
  x.open("GET", url, true);
  x.responseType = "blob";
  x.onload = function(e) {
    downloadjs(e.target.response, name);
  };
  x.send();
}
